import { Injectable } from '@angular/core';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
  lv: { // Latvian
    weekdays: ['Pr', 'Ot', 'Tr', 'Ce', 'Pk', 'Se', 'Sv'],
    months: [
      'Janvāris', 'Februāris', 'Marts', 'Aprīlis', 'Maijs', 'Jūnijs',
      'Jūlijs', 'Augusts', 'Septembris', 'Oktobris', 'Novembris', 'Decembris'
    ],
    weekLabel: 'Nedēļa'
  },
  en: {
    weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekLabel: 'Week'
  }
};

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  language = localStorage.getItem('language') || 'lv';

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.language as keyof typeof I18N_VALUES].weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this.language as keyof typeof I18N_VALUES].months[month - 1];
  }

  getMonthFullName(month: number): string {
    return I18N_VALUES[this.language as keyof typeof I18N_VALUES].months[month - 1];
  }

  getDayAriaLabel(date: import('@ng-bootstrap/ng-bootstrap').NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  override getWeekLabel(): string {
    return I18N_VALUES[this.language as keyof typeof I18N_VALUES].weekLabel;
  }

  override getWeekdayLabel(weekday: number): string {
    return I18N_VALUES[this.language as keyof typeof I18N_VALUES].weekdays[weekday - 1];
  }
}